import moment, { Moment } from 'moment';

export const disableDateBeforeToday = (current?: Moment) => {
  return current && current < moment().startOf('day');
};
